import React, { PropsWithChildren, useEffect, useState, useCallback } from 'react'
import clsx from 'clsx'
import { Layout, Dropdown, Menu, Space, Badge, Avatar } from 'antd'
import {
  logout,
  spiderLogout,
  changeAccount,
  getManageAccount,
  getUnreadMessageCount,
  getWechatKanBanSenceQrCode,
  Account
} from '@/services/mendian'
import { QRCodeDropdown } from './qrcode-dropdown'
import styles from './header.module.less'
import { getLoginInfo } from '@/services/api'
import { setCookie } from '@/utils/cookie'
import { USE_NEW_LAYOUT_COOKIE, N, NEW_LAYOUT_COOKIE_AGE } from '@/constant'

const useManageAccounts = () => {
  const [companyId, setCompanyId] = useState<number>(1)
  const [accounts, setAccounts] = useState<Account[]>([])
  useEffect(() => {
    getManageAccount().then((res) => {
      setCompanyId(res.id)
      setAccounts(res.list)
    })
  }, [])
  return {
    companyId,
    accounts
  }
}

export const User = () => {
  const [userInfo, setUserInfo] = useState<any>({})
  const { accounts = [], companyId } = useManageAccounts()

  useEffect(() => {
    getLoginInfo().then((res: any) => {
      const data = res.data || {}
      setUserInfo(data)
    })
  }, [])

  const logMeOut = async () => {
    try {
      if (location.hostname.includes('fangzhentan')) {
        // 爬虫网站登出逻辑
        const res: any = await spiderLogout()
        if (parseInt(res.code) === 0) {
          window.location.href = '/portal/login'
        }
      } else {
        const res = await logout()
        if (!res) {
          window.location.href = '/logout'
        }
      }
    } catch (error) {
      window.location.href = '/logout'
    }
  }

  const switchAccount = (account: Account) => {
    if (companyId) {
      changeAccount({
        changeAccountId: account.id,
        masterAccountId: companyId
      }).then(({ url }: any) => {
        if (typeof url === 'string') {
          window.location.href = url
        }
      })
    }
  }

  const userList = (accounts || []).map(account => {
    return (
      <Menu.Item
        key={account.id}
        className={clsx(styles.account, { [styles.active]: companyId === account.id })}
        active={account.id === companyId}
        onClick={() => switchAccount(account)}
      >
        <>
          <div className={styles.accountCompany}>
            <i className={ companyId === account.id ? 'iconbroker-check-circle' : 'iconbroker-swap'} />
            <span className={styles.info}>{account.companyName}</span>
          </div>
          <div className={styles.accountUserinfo}>
            <span className={styles.info}>{account.cityName}-{account.userName}</span>
          </div>
        </>
      </Menu.Item>
    )
  })

  userList.push(
    <Menu.Item key="logout" className={clsx({ [styles['is-dock']]: userList.length > 5 })} onClick={() => logMeOut()}>
      <div className={styles.accountCompany}>
        <i className="iconbroker-export" />
        <span className={styles.info}>退出登录</span>
      </div>
    </Menu.Item>
  )

  const accountMenu = (
    <Menu className={styles.accountMenu}>
      {userList}
    </Menu>
  )

  return (
    <Dropdown
      overlay={accountMenu}
      placement={'bottomRight'}
      overlayClassName={clsx(styles.accountMenuOverlay, { [styles.accountNone]: userList.length <= 1 }) }
      arrow
    >
      <div className={styles.userInfo}>
        { userInfo?.trueName &&
          <>
            <Avatar
              className={styles.avatar}
              src="//pages.anjukestatic.com/fe/esf/img/26389b51/comm_head_sculpture.png"
            />
            <span className={styles.name}>{userInfo?.trueName}</span>
            <i className="iconbroker-down" />
          </>
        }
      </div>
    </Dropdown>
  )
}

const hostName = location.hostname
const isStandaloneCompanyHouseList = location.pathname.endsWith('/solar/mix/companyhouse/list__hl')
const threenetsLogoUrl = '//pages.anjukestatic.com/fe/esf/img/e2baf935/log_threenets@2x.png'

let logoUrl = isStandaloneCompanyHouseList
  ? threenetsLogoUrl
  : '//pic4.58cdn.com.cn/nowater/fangfe/n_v24e579fe0ee494e7da2d78bf7c8a6ebae.png'
if (!isStandaloneCompanyHouseList && hostName.includes('jikejia')) {
  logoUrl = '//pic1.58cdn.com.cn/nowater/fangfe/n_v24d01bd7bfef14290b4515f58d6403062.png'
} else if (!isStandaloneCompanyHouseList && hostName.includes('yfyk')) {
  logoUrl = '//pic3.58cdn.com.cn/nowater/fangfe/n_v2ef85df0a6aac4c62a982e0aa607c7e24.png'
} else if (!isStandaloneCompanyHouseList && hostName.includes('fangzhentan')) {
  // 爬虫网站隐藏图标
  logoUrl = '//pic8.58cdn.com.cn/nowater/fangfe/n_v29304ab63b7494082acc00910c2934f79.png'
}

export interface HeaderProps {
  className?: string;
  useOnlyNewLayout: boolean; // 控制版本切换入口
}

const NewMetisHeader = (props: PropsWithChildren<HeaderProps>) => {
  const [redDotVisible, setRedDotVisible] = useState(false)

  const onGetQrCode = async () => {
    return getWechatKanBanSenceQrCode().then(res => {
      return {
        qrCodeUrl: res.qrCodeUrl
      }
    })
  }

  const toggleLayout = useCallback(() => {
    setCookie(USE_NEW_LAYOUT_COOKIE, N, NEW_LAYOUT_COOKIE_AGE)
    window.loggerAction.sendnpv({
      action: 'switch_old_layout_version'
    })
    location.reload()
  }, [])

  useEffect(() => {
    getUnreadMessageCount().then(res => {
      const { list = [] } = res || {}
      setRedDotVisible(Array.isArray(list) && list.some((item: { messageCount: number }) => item.messageCount > 0))
    })
  }, [])

  return (
    <Layout.Header className={clsx(styles.header, styles['is-new'], props.className)}>
      <div className={clsx(styles.inner, { [styles.standalone]: isStandaloneCompanyHouseList })}>
        <div className={styles.logo}>
          <a href="/">
            <img src={logoUrl} className={clsx({ [styles.threenetsLogo]: isStandaloneCompanyHouseList })} />
          </a>
        </div>

        <div className={styles.link}>
          <Space>
            {!props.useOnlyNewLayout && (
              <a
                className={styles.useOldLayout}
                href="javascript: void(0);"
                onClick={toggleLayout}
              >
                <i className="iconbroker-swap" />
                <span>返回旧版</span>
              </a>
            )}
            <QRCodeDropdown
              slogan={'手机看数据 · 更快更简单'}
              onGetQrCode={onGetQrCode}
            />
            <a
              href="//h5.anjuke.com/broker/policy/store-vip-qualifications-rule-new"
              target="_blank"
              rel="noreferrer"
            >
              <i className="iconbroker-menu-certificate" />
            </a>
            <a
              href="//vip.anjuke.com/intelligent_chat/pc#/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="iconbroker-menu-customerservice" />
            </a>
            <a
              href="/help/helpList"
              target="_blank"
              rel="noreferrer"
            >
              <i className="iconbroker-menu-question"></i>
            </a>
            <a
              href="/notice/toNoticeCenter"
              target="_blank"
              rel="noreferrer"
            >
              <Badge dot={redDotVisible}>
                <i className="iconbroker-menu-notice" />
              </Badge>
            </a>
            <User />
          </Space>
        </div>
      </div>
    </Layout.Header>
  )
}

export { NewMetisHeader }
